import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { Link } from 'react-router-dom';
import 'animate.css';

export const DeleteAccount = () => {
  return (
    <section className="delete-account" style={{marginTop: '40px'}}>
      <Container>
        <Row className="align-items-center">
          <Col>
            <h1>Delete Your Account</h1>
            <div className="delete-account-content">
              <h2>How to Delete Your Account</h2>
              <p>Delete your Style AI account by following these steps:</p>
              <ol>
                <li>Log in to your account in the app</li>
                <li>Tap on the settings icon to navigate to the Settings page</li>
                <li>Scroll down and tap on the "Delete Account" button</li>
                <li>Confirm your decision when prompted</li>
              </ol>
              
              <h2>What Happens to Your Data</h2>
              <p>When you delete your account:</p>
              <ul>
                <li><strong>Deleted immediately:</strong> Personal information, profile data, and user preferences</li>
                <li><strong>Deleted within 90 days:</strong> Backup and cached data</li>
                <li><strong>Retained:</strong> Anonymized usage statistics that cannot be traced back to your identity</li>
                <li><strong>Legal requirements:</strong> Some information may be retained if required by law for the necessary period</li>
              </ul>
              
              <h2>Need Help?</h2>
              <p>If you're having trouble deleting your account or have questions about your data, please contact our support team at <a href="mailto:support@vancityvirallabs.com">support@vancityvirallabs.com</a>.</p>
              
              {/* <div className="back-link">
                <Link to="/">Return to Home Page</Link>
              </div> */}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
} 